import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { Link } from "gatsby";
import React, { useEffect, useRef } from "react";
import ReactGA from "react-ga";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useInView } from "../../hooks/useInView";
import Image from "./Image";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

export function LatestNewsCarousel({ allContentNewest }) {
  const latestNewsCarouselRef = useRef(null);

  const isInView = useInView(latestNewsCarouselRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - Últimas notícias - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - Últimas notícias - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <>
      <Typography
        variant="title"
        size={4}
        asChild
        className="eva-text-center eva-margin-bottom-4"
      >
        <p ref={latestNewsCarouselRef}>Últimas notícias</p>
      </Typography>
      <section className="container-fluid">
        <div className="container container-blocks">
          <Typography variant="title" size={4} asChild>
            <p>{allContentNewest?.title}</p>
          </Typography>
          <Typography variant="body" size={2} asChild>
            <p>{allContentNewest?.subtitle}</p>
          </Typography>
          <Swiper
            breakpoints={{
              320: {
                slidesPerView: 1.2,
              },
              480: {
                slidesPerView: 3,
              },
              640: {
                slidesPerView: 4,
              },
            }}
            slidesPerView={4}
            spaceBetween={15}
            navigation={allContentNewest.nodes.length > 4}
            modules={[Navigation]}
            className="eva-react-carrossel eva-margin-bottom-4"
            id={allContentNewest.nodes[0]?.title}
          >
            {allContentNewest.nodes.map((itemCarousel, index) => (
              <SwiperSlide
                key={`item-${itemCarousel.title}`}
                id={`card-${allContentNewest.nodes[0].title}-${itemCarousel.index}`}
              >
                <div className="eva-card eva-bg-branco">
                  <Link
                    to={itemCarousel.url}
                    data-track={`SITE: Click - Nova página de conteúdo - destaque últimas notícias ${
                      index + 1
                    }`}
                    onClick={() => {
                      ReactGA.event({
                        action: "Click",
                        category: "SITE",
                        label: `Nova página de conteúdo - destaque últimas notícias ${
                          index + 1
                        }`,
                      });
                    }}
                  >
                    <div className="eva-card-img">
                      <div className="eva-card-bg"></div>
                      <Image
                        remoteImage={itemCarousel?.featuredImage}
                        fallbackImageUrl={itemCarousel?.featuredImage}
                        className="card-img"
                        alt={itemCarousel.title}
                      />
                    </div>
                    <div className="eva-card-info">
                      <p className="eva-card-title eva-text-bold">
                        {itemCarousel.title}
                      </p>
                      <p className="eva-card-description">
                        {itemCarousel.excerpt}
                      </p>
                      <Button
                        asChild
                        color="black"
                        type="button"
                        className="eva-btn-solid eva-btn-cinza-700 eva-btn-medium eva-btn-full eva-margin-top-2"
                      >
                        <p>ler reportagem</p>
                      </Button>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}
